import Movements from "../../../screens/private/report/movements";
export default Movements;
